import React from "react";
//import MultiImageInput from "react-multiple-image-input";

//import "./CustomImage.css";

class CustomImageUploadField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [], // Store files in state
    };
    this.imgPreviewImag = React.createRef();
  }

  // Generate preview for a single file
  generatePreviewData = (file) => {
    const fr = new FileReader();
    return new Promise((resolve, reject) => {
      fr.addEventListener("load", () => {
        resolve(fr.result);
      });
      fr.addEventListener("error", reject);
      fr.readAsDataURL(file);
    });
  };

  // Clear all children from a container
  removeAllChildren = (el) => {
    while (el.firstChild) {
      el.removeChild(el.firstChild);
    }
  };

  // Handle file deletion
  handleDelete = (index) => {
    this.setState(
      (prevState) => ({
        files: prevState.files.filter((_, i) => i !== index),
      }),
      () => {
        this.renderCollection(this.state.files, this.imgPreviewImag.current);
        // Send updated files to parent
        if(this.state.files){
          this.props.updateFiles(this.state.files);
        }
       
      }
    );
  };

  // Render the collection of images
  renderCollection = (files, container) => {
    this.removeAllChildren(container);
    Promise.all(files.map(this.generatePreviewData)).then((previews) => {
      previews.forEach((src, index) => {
        const div = document.createElement("div");
        div.style.position = "relative";

        const img = document.createElement("img");
        img.src = src;
        img.setAttribute("class", "border rounded img-preview");
        img.setAttribute("width", "200px");
        img.setAttribute("height", "200px");

        const deleteButton = document.createElement("button");
        deleteButton.innerText = "X";
        deleteButton.style.position = "absolute";
        deleteButton.style.top = "5px";
        deleteButton.style.right = "5px";
        deleteButton.style.background = "red";
        deleteButton.style.color = "white";
        deleteButton.style.border = "none";
        deleteButton.style.borderRadius = "50%";
        deleteButton.style.cursor = "pointer";
        deleteButton.style.width = "24px";
        deleteButton.style.height = "24px";

        deleteButton.addEventListener("click", () => this.handleDelete(index));

        div.appendChild(img);
        div.appendChild(deleteButton);
        container.appendChild(div);
      });
    });
  };

  // Handle file input change
  onChangeFile = (e) => {
    const newFiles = Array.from(e.target.files).filter((f) => {
      if (f.type === "" || f.type.search("image") === -1 || f.type === "image/webp") {
        return false;
      }
      const fileSizeKB = Math.round(f.size / 1024);
      if (fileSizeKB >= 4096) {
        return false; // Skip large files
      }
      return true;
    });

    this.setState(
      (prevState) => ({
        files: [...prevState.files, ...newFiles],
      }),
      () => {
        this.renderCollection(this.state.files, this.imgPreviewImag.current);
        // Send updated files to parent
        this.props.addFiles(this.state.files);
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <input
          name="images[]"
          type="file"
          id="pictures"
          accept="image/*"
          multiple
          onChange={this.onChangeFile}
        />
        <div ref={this.imgPreviewImag} style={{ display: "flex", flexWrap: "wrap", gap: "10px" }} />
      </React.Fragment>
    );
  }
}

export default CustomImageUploadField;